/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Zoom_InInputs */



/**
* | output |
* | --- |
* | "Zoom in on the Timeline" |
*
* @param {Shortcut_Keys_Desc_Timeline_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_zoom_in = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Zoom_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Zoom_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoomer sur la timeline")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste vergrößern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ingrandisci la sequenza temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте масштаб временной шкалы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ampliar la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインを拡大する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन पर ज़ूम इन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aproxime o zoom na Linha do Tempo")
	return /** @type {LocalizedString} */ ("Zoom in on the Timeline")
});